import { render, staticRenderFns } from "./upholstery.vue?vue&type=template&id=027e98b4&scoped=true&"
import script from "./upholstery.vue?vue&type=script&lang=js&"
export * from "./upholstery.vue?vue&type=script&lang=js&"
import style0 from "./upholstery.vue?vue&type=style&index=0&id=027e98b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e98b4",
  null
  
)

export default component.exports